import React from 'react';

import TypeaheadTextField from './TypeaheadTextField';

interface ControlledTypeaheadTextFieldProps {
  name: string;
  label: string;
  value?: { label: string; value: any } | null;
  onChange?: (option: { label: string; value: any } | null) => void;
  getOptions: (term: string) => Promise<{ label: string; value: any }[]>;
  disabled?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
  PaperComponent?: any;
}

function ControlledTypeaheadTextField(props: ControlledTypeaheadTextFieldProps) {
  const { value, onChange, name, label, getOptions, disabled, fullWidth, placeholder, PaperComponent } = props;

  return (
    <TypeaheadTextField
      name={name}
      label={label}
      getOptions={getOptions}
      disabled={disabled}
      fullWidth={fullWidth}
      placeholder={placeholder}
      PaperComponent={PaperComponent}
      value={value}
      onChange={(_, newValue) => onChange?.(newValue as { label: string; value: any } | null)}
    />
  );
}

export default ControlledTypeaheadTextField;